import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdWhatsapp } from "react-icons/md";
import { FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from '../assets/logo.png'
import logo_icon from '../assets/logo_icon.png'

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">

						{/* TITLE */}
						<div className="col-md-12">
							<h6 className="main-section-title">
								Contact Us
								<span
									style={{
										display: "block",
										borderBottom: "3px solid var(--secondaryColor)",
										width: "50px",
										marginTop: "10px"
									}}
								/>
							</h6>
						</div>

						{/* LOGO */}
						<div className="col-md-12 bg-primary">
							<div 
								className="text-center"
								style={{ padding: "30px" }}
							>
								<img src={logo_icon} style={{ width: "100px" }} />
								<br/>
								<img src={logo} style={{ width: "250px" }} />
							</div>
						</div>

						{/* CONTACT DETAILS */}
						<div className="col-md-12 mt-3">

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => window.open('mailto:info@tyidi.or.tz', '_blank')}
								className="font-bold text-dark"
							>
								<MdEmail size={32}/> info@tyidi.or.tz
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => window.open('tel:+255756528022', '_blank')}
								className="font-bold text-dark"
							>
								<MdCall size={32}/> +255 756 528 022
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => window.open("https://wa.me/255756528022", "_blank")}
								className="font-bold text-dark"
							>
								<MdWhatsapp size={32}/> Chat with us on WhatsApp
							</h6>

							<h6
								style={{ fontSize: "14px", padding: "10px" }}
								className="font-bold text-dark"
							>
								<MdLocationPin size={32}/> 
								P.O. Box 1212, Kigoma, Kigoma Region, Tanzania
							</h6>

						</div>

						{/* SOCIAL MEDIA */}
						<div className="col-md-12 mt-4">
							<h6
								className="font-bold text-center mb-3 text-primary"
								style={{ fontSize: "24px" }}
							>
								Follow Us On Social Media
							</h6>

							<div className="row text-center">

								<div className="col-4 col-md-2 mb-3">
									<FaInstagram
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.instagram.com/tyidi2026", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>Instagram</div>
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaFacebook
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.facebook.com/@TyidiTanzania", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>Facebook</div>
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaLinkedin
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.linkedin.com/in/tyidi-tanzania-9434793a5", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>LinkedIn</div>
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaYoutube
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.youtube.com/@tanzaniayouthIntergrateddevelo", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>YouTube</div>
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaTiktok
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.tiktok.com/@tyidi2025", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>TikTok</div>
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaXTwitter
										size={36}
										style={{ cursor: "pointer" }}
										onClick={() => window.open("https://x.com/Tyidi2026", "_blank")}
									/>
									<div style={{ fontSize: "12px" }}>X</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
